import { userRoles } from "./constants";

export const superAdminDelete = userRoles.SUPER_ADMIN_DELETE;
export const superAdmin = userRoles.SUPER_ADMIN;
export const support = userRoles.SUPPORT;
export const admin = userRoles.ADMIN;

export const PermittedRoles = {
  PLAYERS: {
    PBF_PLAYERS_LIST: [superAdmin, superAdminDelete, admin, support],
    TFG_PLAYERS_LIST: [superAdmin, superAdminDelete, admin, support],
    TFG_PLAYER_UPDATE: [superAdmin, superAdminDelete, admin],
  },
  BOOSTERS: {
    LIST_ROLES: [superAdmin, superAdminDelete],
  },
  BRAND: {
    INFO_ROLES: [superAdmin, superAdminDelete],
    LIST_ROLES: [superAdmin, superAdminDelete, admin],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
    DELETE_ROLES: [superAdminDelete],
  },
  CLUB: {
    INFO_ROLES: [superAdmin, superAdminDelete],
    LIST_ROLES: [superAdmin, superAdminDelete, admin],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
    DELETE_ROLES: [superAdminDelete],
  },
  COUNTRIES: {
    LIST_ROLES: [superAdmin, superAdminDelete, admin, support],
  },
  GAME: {
    INFO_ROLES: [],
    LIST_ROLES: [],
    CREATE_ROLES: [superAdmin, superAdminDelete, admin],
    UPDATE_ROLES: [superAdmin, superAdminDelete, admin],
  },
  MASTER_GAME: {
    INFO_ROLES: [superAdmin, superAdminDelete, admin],
    LIST_ROLES: [superAdmin, superAdminDelete, admin, support],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    EDIT_ROLES: [superAdmin, superAdminDelete, admin],
    UPDATE_ROLES: [superAdmin, superAdminDelete, admin],
  },
  LEAGUE: {
    INFO_ROLES: [superAdmin, superAdminDelete],
    LIST_ROLES: [superAdmin, superAdminDelete, admin],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
  },
  MISC: {
    OVR_FORMULA_ROLES: [superAdmin, superAdminDelete, admin, support],
    LANGUAGES_ROLES: [superAdmin, superAdminDelete, admin, support],
    TRANSLATION_UPLOAD_ROLES: [superAdmin, superAdminDelete, admin, support],
  },
  OPERATOR: {
    INFO_ROLES: [superAdmin, superAdminDelete],
    LIST_ROLES: [superAdmin, superAdminDelete, admin],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
    LIST_BASE_MARKET: [superAdmin, superAdminDelete, admin],
    UPDATE_BASE_MARKET: [superAdmin, superAdminDelete],
    DELETE_ROLES: [superAdminDelete],
  },
  OPERATOR_GAME: {
    INFO_ROLES: [superAdmin, superAdminDelete],
    LIST_ROLES: [superAdmin, superAdminDelete, admin],
    CREATE_ROLES: [superAdmin, superAdminDelete, admin],
    UPDATE_ROLES: [superAdmin, superAdminDelete, admin],
    SYNC_GAMES_LIST_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ALL_OPERATOR_GAMES_ROLES: [superAdmin, superAdminDelete, admin],
  },
  OPERATOR_GAMES: {
    INFO_ROLES: [superAdmin, superAdminDelete, admin],
    LIST_ROLES: [superAdmin, superAdminDelete, admin, support],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    EDIT_ROLES: [superAdmin, superAdminDelete, admin],
    UPDATE_ROLES: [superAdmin, superAdminDelete, admin],
    DELETE_ROLES: [superAdminDelete],
  },
  PLATFORM: {
    INFO_ROLES: [superAdmin, superAdminDelete],
    LIST_ROLES: [superAdmin, superAdminDelete, admin],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
    DELETE_ROLES: [superAdminDelete],
  },
  STORE: {
    INFO_ROLES: [superAdmin, superAdminDelete],
    LIST_ROLES: [superAdmin, superAdminDelete, admin],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
    DELETE_ROLES: [superAdminDelete],
  },
  PLAYER: {
    TEMPLATE: {
      LIST_ROLES: [superAdmin, superAdminDelete],
      CREATE_ROLES: [superAdmin, superAdminDelete],
    },
    CARD: {
      INFO_ROLES: [superAdmin, superAdminDelete],
      LIST_ROLES: [superAdmin, superAdminDelete, admin],
      CREATE_ROLES: [superAdmin, superAdminDelete],
      UPDATE_ROLES: [superAdmin, superAdminDelete],
      DELETE_ROLES: [superAdminDelete],
    },
    PACK: {
      INFO_ROLES: [superAdmin, superAdminDelete],
      LIST_ROLES: [superAdmin, superAdminDelete, admin],
      CREATE_ROLES: [superAdmin, superAdminDelete],
      UPDATE_ROLES: [superAdmin, superAdminDelete],
      PREDEFINED_IMAGES_ROLES: [superAdmin, superAdminDelete],
      DELETE_ROLES: [superAdminDelete],
    },
  },
  POSITION: {
    INFO_ROLES: [superAdmin, superAdminDelete],
    LIST_ROLES: [superAdmin, superAdminDelete, admin],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
    DELETE_ROLES: [superAdminDelete],
  },
  USER: {
    LIST_ROLES: [],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
  },
  REPORT: {
    INFO_ROLES: [superAdmin, superAdminDelete, admin, support],
  },
  DASHBOARD: {
    INFO_ROLES: [superAdmin, superAdminDelete, admin, support],
  },
  CURRENCY: {
    INFO_ROLES: [superAdmin, superAdminDelete],
    LIST_ROLES: [superAdmin, superAdminDelete, admin],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
    DELETE_ROLES: [superAdminDelete],
  },
  BANNERS: {
    INFO_ROLES: [superAdmin, superAdminDelete],
    LIST_ROLES: [superAdmin, superAdminDelete, admin],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
    DELETE_ROLES: [superAdminDelete],
  },
  SPLASH_SCREEN: {
    INFO_ROLES: [superAdmin, superAdminDelete],
    LIST_ROLES: [superAdmin, superAdminDelete, admin],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
    DELETE_ROLES: [superAdminDelete],
  },
  CHALLENGES: {
    INFO_ROLES: [superAdmin, superAdminDelete, admin],
    LIST_ROLES: [superAdmin, superAdminDelete, admin],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
    DELETE_ROLES: [superAdminDelete],
  },
  BADGES: {
    LIST_ROLES: [superAdmin, superAdminDelete, admin],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
  },
  OBJECTIVE_TYPE_TITLES: {
    INFO_ROLES: [superAdmin, superAdminDelete, admin],
    LIST_ROLES: [superAdmin, superAdminDelete, admin],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
    DELETE_ROLES: [superAdminDelete],
  },
  CHALLENGE_REWARD_IMAGES: {
    INFO_ROLES: [superAdmin, superAdminDelete, admin],
    LIST_ROLES: [superAdmin, superAdminDelete, admin],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
    DELETE_ROLES: [superAdminDelete],
  },
  DAILYREWARDS: {
    INFO_ROLES: [superAdmin, superAdminDelete],
    LIST_ROLES: [superAdmin, superAdminDelete, admin],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
    DELETE_ROLES: [superAdminDelete],
  },
  TRANSLATION: {
    CREATE_ROLES: [superAdmin, superAdminDelete, admin],
  },
  CARD_BACKGROUND: {
    INFO_ROLES: [superAdmin, superAdminDelete],
    LIST_ROLES: [superAdmin, superAdminDelete, admin],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
    DELETE_ROLES: [superAdminDelete],
  },
  VAULT_REWARDS_AND_DROP_RATES: {
    INFO_ROLES: [superAdmin, superAdminDelete],
    LIST_ROLES: [superAdmin, superAdminDelete, admin],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
    DELETE_ROLES: [superAdminDelete],
  },
  PACK_CATEGORY: {
    INFO_ROLES: [superAdmin, superAdminDelete],
    LIST_ROLES: [superAdmin, superAdminDelete, admin],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
    DELETE_ROLES: [superAdminDelete],
  },
  NOTIFICATIONS: {
    INFO_ROLES: [superAdmin, superAdminDelete],
    LIST_ROLES: [superAdmin, superAdminDelete, admin],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
    DELETE_ROLES: [superAdminDelete],
  },
  STORE_BANNERS: {
    INFO_ROLES: [superAdmin, superAdminDelete],
    LIST_ROLES: [superAdmin, superAdminDelete, admin],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
    DELETE_ROLES: [superAdminDelete],
  },
  SELL_PLAYER: {
    CREATE_ROLES: [superAdmin, superAdminDelete, admin],
    DELETE_ROLES: [superAdminDelete],
  },
  QUICK_BET: {
    INFO_ROLES: [superAdmin, superAdminDelete],
    LIST_ROLES: [superAdmin, superAdminDelete, admin],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
    DELETE_ROLES: [superAdminDelete],
  },
  CONFIGURATIONS: {
    UPDATE_ROLES: [superAdmin, superAdminDelete],
  },
  BOT_AND_GHOST_TEAM_MANAGEMENT: {
    UPDATE_ROLES: [superAdmin, superAdminDelete],
  },
  FTUE_PACK_MANAGEMENT: {
    UPDATE_ROLES: [superAdmin, superAdminDelete],
  },
  EOS_REWARD_CONFIG: {
    INFO_ROLES: [superAdmin, superAdminDelete],
    LIST_ROLES: [superAdmin, superAdminDelete, admin],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
    DELETE_ROLES: [superAdminDelete],
  },
  LOGOS: {
    ALLOWED_ROLES: [superAdmin, superAdminDelete],
  },
  ALL_USERS: {
    ALLOWED_ROLES: [superAdmin, superAdminDelete, admin],
  },
  RECALCULATE_TEAM_RATINGS: {
    INITIATION: [superAdmin, superAdminDelete],
    LIST_ROLES: [superAdmin, superAdminDelete],
  },
  FATIGUE_CONFIG: {
    LIST_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
  },
  WEEKLY_LEADERBOARD_CONFIG: {
    LIST_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
  },
  WEEKLY_LEADERBOARD: {
    VIEW_ROLES: [superAdmin, superAdminDelete, admin, support],
  },
  USER_MANAGEMENT: {
    LIST_ROLES: [superAdmin, superAdminDelete],
    CREATE_ROLES: [superAdminDelete],
    UPDATE_ROLES: [superAdminDelete],
    DELETE_ROLES: [superAdminDelete],
  },
  PORTAL_USER: {
    LIST_ROLES: [superAdmin, superAdminDelete],
    CREATE_ROLES: [superAdminDelete],
    UPDATE_ROLES: [superAdminDelete],
    DELETE_ROLES: [superAdminDelete],
    RESET_PASSWORD_ROLES: [superAdminDelete],
    UNLOCK_ROLES: [superAdminDelete],
    AUDIT_LOG_ROLES: [superAdmin, superAdminDelete],
  },
  REPORT_SCHEDULER: {
    LIST_ROLES: [superAdmin, superAdminDelete],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
    DELETE_ROLES: [superAdmin, superAdminDelete],
    TEST_ROLES: [superAdmin, superAdminDelete],
    RUN_HISTORY_ROLES: [superAdmin, superAdminDelete],
    TOGGLE_ROLES: [superAdmin, superAdminDelete],
  },
  ADMIN_CREDENTIALS: {
    ALLOWED_ROLES: [superAdminDelete],
  },
  WORLD_CUP_MODE: {
    TOGGLE_ROLES: [superAdmin, superAdminDelete],
  },
  QUEUE_MONITORING: {
    VIEW_ROLES: [superAdmin, superAdminDelete, admin, support],
    RETRY_ROLES: [superAdmin, superAdminDelete],
    ADMIN_ROLES: [superAdminDelete],
  },
  TUTORIAL: {
    LIST_ROLES: [superAdmin, superAdminDelete, admin],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
    DELETE_ROLES: [superAdminDelete],
    UPLOAD_ROLES: [superAdmin, superAdminDelete],
  },
   OPERATOR_LOGO: {
    LIST_ROLES: [superAdmin, superAdminDelete, admin],
    CREATE_ROLES: [superAdmin, superAdminDelete],
    UPDATE_ROLES: [superAdmin, superAdminDelete],
    DELETE_ROLES: [superAdminDelete],
  },
};
